import type { Styles } from '@adornis/ass/style.js';
import type { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { XTableView } from '@adornis/data-view/client/x-data-view-table.js';
import { customElement } from 'lit/decorators.js';

/**
 * @customElement cr-data-view-table
 */
@customElement('cr-data-view-table')
export class CrDataViewTable<T extends typeof AdornisEntity> extends XTableView<T> {
  override styles(): Styles[] {
    return [
      ...super.styles(),
      {
        [`[row]:nth-child(even) > cr-flex:not([active])`]: {
          background: this.colors.neutral.shade(50),
        },
        [`[row]:nth-child(odd) > cr-flex:not([active])`]: {
          background: this.colors.neutral.shade(100),
        },

        '.header-text': { background: this.colors.neutral.shade(100) },
        '.header-text cr-h4': { fontWeight: '550' },
      },
    ];
  }
}
